import { computed } from 'vue';
import { parentAlignmentType, viewType } from 'shared/constants.json';
import { useI18n } from 'vue-i18n';

export default function useParentAlignment(savedView) {
  const { t } = useI18n();

  const parentAlignmentOptions = [
    { text: t('parentAlignment.hidden'), value: parentAlignmentType.hidden, tooltip: t('parentAlignment.hiddenDescription') },
    { text: t('parentAlignment.direct'), value: parentAlignmentType.direct, tooltip: t('parentAlignment.directDescription') },
    { text: t('parentAlignment.minimal'), value: parentAlignmentType.minimal, tooltip: t('parentAlignment.minimalDescription') },
    { text: t('parentAlignment.full'), value: parentAlignmentType.full, tooltip: t('parentAlignment.fullDescription') },
  ];

  const defaultParentAlignment = (type) => {
    if ([viewType.cascade, viewType.tree].includes(type)) {
      return parentAlignmentType.full;
    }
    return parentAlignmentType.hidden;
  };

  const parentAlignmentLabel = computed(() => t('parentAlignment.label'));

  const parentAlignment = computed(() => {
    if (![viewType.cascade, viewType.tree].includes(savedView.value.viewType)) {
      return parentAlignmentType.hidden;
    }

    if (savedView.value.params?.parentAlignment !== undefined) {
      return savedView.value.params.parentAlignment;
    }

    return defaultParentAlignment(savedView.value.viewType);
  });

  return { parentAlignmentOptions, defaultParentAlignment, parentAlignment, parentAlignmentLabel };
}
